import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FormsModule } from '@angular/forms';
import { MatLegacyOptionModule } from '@angular/material/legacy-core';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import {
  AngleMode,
  AngleSettingsHelper,
  Countertop,
  CountertopAngleProcessingAvailability,
  CountertopAngleProcessingBase,
  MaterialType,
} from 'cloud-shared-lib';
import _ from 'lodash';
import { Observable, of } from 'rxjs';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  selector: 'csl-angle-mode-select',
  templateUrl: './angle-mode-select.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgIf,
    MatLegacyFormFieldModule,
    NgClass,
    ExtendedModule,
    MatLegacySelectModule,
    FormsModule,
    MatLegacyOptionModule,
    AsyncPipe,
    PipesModule,
  ],
})
export class AngleModeSelectComponent implements OnInit, OnChanges {
  // outlineOptions: OutlineEditorOptions;
  thisAngleMode = AngleMode;
  // private _angles: CuttingPanelOutline<CuttingPanelBaseSlot> = undefined;
  // _mode: AngleMode = AngleMode.None;
  thisMaterialType = MaterialType;
  availableMods$: Observable<Set<AngleMode>>;

  withoutProcessingText = $localize`Нет`;

  // get angles(): CuttingPanelOutline<CuttingPanelBaseSlot> {
  //   return this._angles;
  // }
  angleNeighbor: { left?: CountertopAngleProcessingBase; right?: CountertopAngleProcessingBase };

  @Output() modeChange: EventEmitter<AngleMode> = new EventEmitter<AngleMode>();

  @Input() editable = true;
  @Input() mode: AngleMode;
  //   this._mode = value;
  // }
  @Input() countertop: Countertop;
  @Input() angleNumber: string;

  @Input() angleProcessingAvailability: CountertopAngleProcessingAvailability;

  @Input()
  get dense(): boolean {
    return this._dense;
  }
  set dense(value: BooleanInput) {
    this._dense = coerceBooleanProperty(value);
  }
  _dense = false;

  constructor() {}

  ngOnInit(): void {
    this.availableMods$ = of(
      AngleSettingsHelper.getAngleMods({
        ...this.angleProcessingAvailability,
        diagonalCutting: false,
        masonsMitre: false,
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const angle = changes.angleNumber?.currentValue ?? this.angleNumber;
    const countertop = changes.countertop?.currentValue ?? this.countertop;

    if (!_.isNil(countertop) && !_.isNil(angle)) {
      this.angleNeighbor = countertop?.getProcessableNeighborAngles(angle);
    }
  }

  onModeChange(): void {
    this.modeChange.emit(this.mode);
  }

  validDiagonalCut(): boolean {
    return (
      (_.isNil(this.angleNeighbor.left) || this.angleNeighbor.left.mode === AngleMode.None) &&
      (_.isNil(this.angleNeighbor.right) || this.angleNeighbor.right.mode === AngleMode.None)
    );
  }

  hasDiagonalCutNeighbor(): boolean {
    return (
      this.angleNeighbor?.left?.mode === AngleMode.DiagonalCut ||
      this.angleNeighbor?.right?.mode === AngleMode.DiagonalCut
    );
  }
}
